// extracted by mini-css-extract-plugin
module.exports = {"Card":"NextPageCard_Card__Evt9T"};